<!--eslint-disable @angular-eslint/template/eqeqeq-->
<sb-form-field-label [formField]="formField"></sb-form-field-label>
<div class="form-group btn-row sentiments" ngModelGroup="formField{{ formField.id }}">
    <button
        type="button"
        class="btn btn-secondary"
        [ngClass]="{ 'btn-active': formField.value == sentimentsEnum.question }"
        (click)="activate(sentimentsEnum.question)"
        translate>
        Question
    </button>

    <button
        type="button"
        class="btn btn-secondary"
        [ngClass]="{ 'btn-active': formField.value == sentimentsEnum.praise }"
        (click)="activate(sentimentsEnum.praise)"
        translate>
        Praise
    </button>

    <button
        type="button"
        class="btn btn-secondary"
        [ngClass]="{ 'btn-active': formField.value == sentimentsEnum.suggestion }"
        (click)="activate(sentimentsEnum.suggestion)"
        translate>
        Suggestion
    </button>

    <button
        type="button"
        class="btn btn-secondary"
        [ngClass]="{ 'btn-active': formField.value == sentimentsEnum.complaint }"
        (click)="activate(sentimentsEnum.complaint)"
        translate>
        Complaint
    </button>
</div>
